import { downloadData } from '../../../DataAccessLayer';
import { sam } from '../../../DataAccessLayer/services';
import { Link } from '@mui/material';
import { toast } from 'react-toastify';

export const DownloadFile = ({ date, createdAt, fileName, filePath }) => {
  // click handler to fetch & download
  const handleDownload = async () => {
    try {
      const response = await downloadData(
        sam.advisorRules().getFile({
          date,
          createdAt,
        }),
        true,
      );
      if (!response) {
        throw new Error('No response from server.');
      }

      // wrap it in a Blob, preserving the content-type
      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/octet-stream',
      });

      // create a temporary <a> to trigger browser download
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      // cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(`Failed to download ${fileName}.`);
    }
  };

  return fileName && filePath ? (
    <Link sx={{ cursor: 'pointer' }} variant="text" onClick={handleDownload}>
      {fileName}
    </Link>
  ) : (
    <>Not Available</>
  );
};
